import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {APPCONFIG} from '../../config';

@Component({
  selector: 'my-page-500',
  styles: [],
  templateUrl: './500.component.html',
  standalone: false,
})
export class Page500Component implements OnInit {
  constructor(private titleService: Title) {}

  ngOnInit(): void {
    this.titleService.setTitle('Error 500 | ' + APPCONFIG.pageTitle);
  }
}
